import React, { Component } from 'react';
import "./dev-badge.scss";
import { isDevDatabase } from "utils/devBadge";

class DevBadge extends Component {

    render() {
        // the badge only exists while the webadmin is pointed at a dev database
        if (!isDevDatabase()) {
            return null;
        }

        return (
            <div className="dev_badge">DEV</div>
        );
    }
}

export default DevBadge;
